import * as React from "react";
import {IReduxState} from "../reducers";
import {connect} from "react-redux";
import {removeFlags} from "consent/actions";
import {exitWebview, notifyAndroid, notifyAndroidAfterConsentCompletion, notifyAndroidFromWeb, setAndroidTokenAndVersionBeforeRedirecting} from "utils/android";
import {applyUrl, imageBaseUrl, websiteUrl} from "config";
import ConsentBox from "consent/utils/consentBox";
import RoundedButton from "components/roundedButton";
import {partnerOfferings} from "login/config";
import {LoginMode} from "login/reducer";
import {RedirectPath} from "Dashboard";

interface IConnectProps {
    dispatch?: (action: any) => void;
    userId: number;
    partnerName: string;
    isAndroid: boolean;
    isPartnerAndroid: boolean;
    utm_source: string;
    apiVersion: number;
    loginMode: LoginMode;
    authExt?: {[key: string]: string};
}
interface IState {
    pathname: string;
}

const dashboardObject = {
    onStart: {
        linkType: "APP_LINK",
        link: "com.datasignstech.lam.loanaminute.dashboard.Dashboard",
        linkAuth: false,
    },
    onFinish : {
        linkType : "APP_LINK",
        link : "com.datasignstech.lam.loanaminute.dashboard.Dashboard",
        linkAuth: false,
    },
};

class ConsentCompleted extends React.Component<IConnectProps, IState> {
    public constructor(props) {
        super(props);
        this.state = {
            pathname: this.props.partnerName &&
            this.props.partnerName !== "sl" ? `/${this.props.partnerName}` : "/",
        };
        this.redirectToPath = this.redirectToPath.bind(this);
        this.getAllQueryParams = this.getAllQueryParams.bind(this);
    }
    public getAllQueryParams = (authExt) => {
        let allQuery;
        if (authExt && Object.keys(authExt).length) {
            allQuery = Object.keys(authExt)
            .map((key) => `${key}=${authExt[key]}`)
            .join("&");
        }
        return allQuery;
    };
    public redirectToPath = (redirectPath: RedirectPath, params?: string) => {
        const searchParam = params ? `?${params}` : "";
        window.location.replace(`${websiteUrl}/${redirectPath}/#/${searchParam}`);
    };
    public removeFlags() {
        if (this.props.isAndroid && !this.props.isPartnerAndroid) {
            if (this.props.apiVersion >= 201) {
                return exitWebview();
            }
            notifyAndroidAfterConsentCompletion("SUCCESS");
            notifyAndroid("ANDROID_REDIRECT", dashboardObject);
        } else {
            const isSsoLogin = this.props.loginMode === LoginMode.SSO;
            const isLoginV2 = this.props.loginMode === LoginMode.V2;
            this.props.dispatch(removeFlags());
            if (this.props.authExt?.["redirect"] === RedirectPath.Loans || isSsoLogin) {
                this.redirectToPath(RedirectPath.Loans, this.getAllQueryParams(this.props.authExt));
                return;
            } else if (!this.props?.authExt?.accessToken || isLoginV2) {
                this.redirectToPath(RedirectPath.Dashboard, this.getAllQueryParams(this.props.authExt));
                return;
            } else {
                window.open(applyUrl, "_self");
            }
        }
    }
    
    public handleSurveyRedirection = () => {
        if (this.props.isAndroid) {
           return notifyAndroidFromWeb("https://qdeg.in/5K2qabC");
        }
        return window.open("https://qdeg.in/5K2qabC");
    }

    public render() {
        return (
            <ConsentBox>
                <div className="flex-column-center-row" style={{marginTop: 86}}>
                    <div style={{fontSize: 15, fontWeight: 900}}>
                        Thank You
                    </div>
                    <div style={{marginTop: 10, marginLeft: 11}}>
                        <img src={`${imageBaseUrl}/img/consent/consentCompleted.png`}
                             alt="Thank You"
                             style={{width: 108, height: 108}}/>
                    </div>
                    <div style={{fontSize: 14, maxWidth: 192, textAlign: "center", marginTop: 16, marginBottom: 24}}>
                        <div>We have received your details</div>
                        <div>We will contact you shortly</div>
                    </div>
                    {sessionStorage.getItem("eNachMode") && <div className="link" onClick={this.handleSurveyRedirection}>Please share your feedback with NPCI ↗</div>}
                    <RoundedButton bgColor={partnerOfferings[this.props.utm_source]?.colors?.green} buttonText="Go to Homepage" onClick={this.removeFlags.bind(this)} size="small"/>
                </div>
            </ConsentBox>
        );
    }
}

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        userId: state.login.auth.userId,
        loginMode: state.login.loginMode,
        partnerName: state.userform.param,
        authExt: state.login.authExt ? state.login.authExt : null,
        isAndroid: state.login.isAndroid,
        apiVersion: state.login.apiVersion,
        isPartnerAndroid: state.login.isPartnerAndroid,
        utm_source: state.login.authExt && state.login.authExt.utm_source ? state.login.authExt.utm_source : null,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(ConsentCompleted);
